var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecryptAdd02(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#34DAE2;}\n\t.st1{fill:#252A41;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#252A41;}\n\t.st3{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_30",
    className: "st0",
    cx: 12.5,
    cy: 12.5,
    r: 12
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_866",
    transform: "translate(-818.359 -678.359)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_877",
    x: 823.47,
    y: 689.94,
    className: "st3",
    width: 14.77,
    height: 1.85
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_878",
    x: 829.94,
    y: 683.47,
    className: "st3",
    width: 1.85,
    height: 14.77
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecryptAdd02);
export default __webpack_public_path__ + "static/media/recrypt_add02.d3de643b.svg";
export { ForwardRef as ReactComponent };